import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {AccessService} from "../../utils/AccessService";
import {LocalStorage} from "../../utils/LocalStorage";
import { withTranslation } from 'react-i18next';

class AgencyTabsComponent extends Component {

    constructor(props) {
        super(props);

        this.handleGetUserModules = this.handleGetUserModules.bind(this);

        this.state = {
            modules: null
        };
    }

    handleGetUserModules(data) {
        this.setState({
            ...this.state,
            modules: data.modules
        });
    }

    getUserModules() {
        AccessService.GetUserModules(this.getUserId(), this.handleGetUserModules, null)
    }

    getUserId() {
        return LocalStorage.fetchUserId()
    }

    componentDidMount() {
        this.getUserModules();
    }

    renderModuleMarketingTabsAsList() {
        const { t } = this.props;
        if (!this.state.modules.includes(AccessService.MODULE_MARKETING))
            return []

        return [
            <li key="clients">
                <Link className="tab-button" to="/agency/clients">
                    {t('agency_tabs.clients')}
                </Link>
            </li>,
            <li key="clients">
                <Link className="tab-button" to="/agency-team">
                    {t('agency_tabs.team')}
                </Link>
            </li>,
            <li key="ad-accounts">
                <Link className="tab-button" to="/agency/ad-accounts">
                    {t('agency_tabs.accounts')}
                </Link>
            </li>,
            <li key="alerts-configuration">
                <Link className="tab-button" to="/agency/alerts-configuration">
                    {t('agency_tabs.alerts')}
                </Link>
            </li>
        ]
    }

    renderTabs(listOfTabs) {
        return (<ul className={'tabs ' + this.props.activeTab}>{listOfTabs}</ul>);
    }

    render() {
        const { t } = this.props;
        if (!this.state.modules)
            return "";

        const tabs = this.renderModuleMarketingTabsAsList()
        tabs.push(<li key="agency/profile"><Link className="tab-button" to="/agency/profile">{t('agency_tabs.profile')}</Link></li>);
        tabs.push(<li key="agency/conections"><Link className="tab-button" to="/agency/conections">{t('agency_tabs.connections')}</Link></li>);
        tabs.push(<li key="agency/flex-indicators"><Link className="tab-button" to="/agency/flex-indicators">{t('agency_tabs.custom_columns')}</Link></li>);
        tabs.push(<li key="agency/subscription"><Link className="tab-button" to="/agency/subscription">{t('agency_tabs.subscription')}</Link></li>);

        return (
            <div className="filters">
                {this.renderTabs(tabs)}
            </div>
        )
    }
}

export const AgencyTabs = withTranslation()(AgencyTabsComponent);